import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { commandPaletteMessages as messages } from './commandPaletteMessages';
import styles from './PaletteFooter.module.scss';

/** The key hints under the palette. */
const PaletteFooterComponent: React.FC = () => {
  const intl = useIntl();
  return (
    <div className={styles.footer}>
      <span className={styles.footerShortcut}>
        <kbd className={styles.kbd}>&uarr;</kbd>
        <kbd className={styles.kbd}>&darr;</kbd>
        {intl.formatMessage(messages.navigate)}
      </span>
      <span className={styles.footerShortcut}>
        <kbd className={styles.kbd}>&crarr;</kbd>
        {intl.formatMessage(messages.select)}
      </span>
      <span className={styles.footerShortcut}>
        <kbd className={styles.kbd}>⇧↵</kbd>
        {intl.formatMessage(messages.searchHint)}
      </span>
      <span className={styles.footerShortcut}>
        <kbd className={styles.kbd}>Esc</kbd>
        {intl.formatMessage(messages.close)}
      </span>
    </div>
  );
};

export const PaletteFooter = TypedMemo(PaletteFooterComponent);
